import React, { useState } from "react";
import "./MyReservation.css";
import PlanningReservations from "./widgets/PlanningReservations";
import HistoricReservations from "./widgets/HistoricReservations";

const TABS = ["À venir", "Historique"];

const MyReservation = () => {
  const [tab, setTab] = useState(0);

  return (
    <>
      <div className="myres-page">
        <div className="myres-hero">
          <h1 className="myres-hero-title">Mes réservations</h1>
        </div>

        <div className="myres-tabs">
          {TABS.map((label, i) => (
            <button
              key={i}
              className={`myres-tab ${tab === i ? "myres-tab--active" : ""}`}
              onClick={() => setTab(i)}
            >
              {label}
            </button>
          ))}
        </div>

        <div className="myres-content">
          {tab === 0 ? <PlanningReservations /> : <HistoricReservations />}
        </div>
      </div>

    </>
  );
};

export default MyReservation;
